import { Col, Form, FormInstance, Radio, Row, Typography } from 'antd';
import { useIntl } from 'react-intl';
import ReportSelectMonthFields from '@/components/_common/ReportSelectMonthFields';
import {
  FilterByDate,
  Situation,
} from '@/core/domain/reports/commission/ByFinancial/ByFinancial.types';
import ByFinancialSelects from './ByFinancialSelects';
import {
  CheckboxGroupButtons,
  FloatingFormItem,
  InputDecimal,
} from '@/components/_common';
import {
  QuestCommissionByFinancialFormValues,
  QuestFilterBy,
  QuestSituation,
} from '@/core/domain/questReport/Reports/CommissionByFinancial/CommissionByFinancial.types';

interface Props {
  form: FormInstance<QuestCommissionByFinancialFormValues>;
}

const ByFinancialForm: React.FC<Props> = ({ form }) => {
  const intl = useIntl();
  const { Title } = Typography;

  const situationType = [
    {
      label: intl.formatMessage({
        id: 'byFinancialForm.form.situation.open',
      }),

      value: QuestSituation.open,
    },
    {
      label: intl.formatMessage({
        id: 'byFinancialForm.form.situation.settled',
      }),

      value: QuestSituation.settled,
    },
  ];

  return (
    <Form layout="vertical" form={form}>
      <Row gutter={[12, 12]}>
        <ReportSelectMonthFields
          form={form}
          dateFilter={
            <>
              <Title level={5}>
                {intl.formatMessage({
                  id: 'byFinancialForm.form.filterByDate',
                })}
              </Title>

              <Form.Item
                noStyle
                name="filterBy"
                initialValue={FilterByDate.dueDate}
              >
                <Radio.Group
                  optionType="button"
                  buttonStyle="solid"
                  size="large"
                >
                  <Radio value={QuestFilterBy.emissionDate}>
                    {intl.formatMessage({
                      id: 'byFinancialForm.form.filterByDate.emission',
                    })}
                  </Radio>
                  <Radio value={QuestFilterBy.dueDate}>
                    {intl.formatMessage({
                      id: 'byFinancialForm.form.filterByDate.dueDate',
                    })}
                  </Radio>
                  <Radio value={QuestFilterBy.receiptDate}>
                    {intl.formatMessage({
                      id: 'byFinancialForm.form.filterByDate.receipt',
                    })}
                  </Radio>
                </Radio.Group>
              </Form.Item>
            </>
          }
        />

        <Col xs={24}>
          <ByFinancialSelects />
        </Col>

        <Col xs={5}>
          <FloatingFormItem
            name="deduction"
            label={intl.formatMessage({
              id: 'byFinancialForm.form.deduction',
            })}
          >
            <InputDecimal />
          </FloatingFormItem>
        </Col>

        <Col xs={24}>
          <Title level={5}>
            {intl.formatMessage({ id: 'byFinancialForm.form.situation' })}
          </Title>

          <Form.Item name="situation" initialValue={[Situation.open]}>
            <CheckboxGroupButtons options={situationType} />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default ByFinancialForm;
